import React, { useEffect, useState } from 'react'
import { usePublication } from '../../../hooks/usePublication'
import { ButtonsRight } from '../../../interfaces/UI'
import ChapterIndex from './ChapterIndex'
import DataSheet from './DataSheet'
import HelpBook from './HelpBook'
import ModalCredits from './ModalCredits'
import UserOptions from './UserOptions'
import { Authors } from './Authors'
import { References } from './References'
import { useUi } from '../../../hooks'
import { IaChat } from './IA'
import { typeLibro } from '../../../interfaces/Publication'
import { Podcast } from './Podcast'
import ModalFragments from './ModalFragments'
import { ReviewsComponent } from './Reviews'
import FullscreenFragmentViewer from './FullScreenFragment'
import { NotesComponent } from './Notes'
// import DataSheet from './DataSheet';


interface RightSectionProps{
  viewButtons : ButtonsRight
  openButtons : ButtonsRight
  setOpenButtons :  (buttosn : ButtonsRight) => void;
  typeLibro: typeLibro;
}                  


const RightSection = ({viewButtons, openButtons, setOpenButtons, typeLibro} : RightSectionProps) => {


    const [open, setOpen] = useState(true)
    const { isOpenSideBar } = useUi();
    
    
    useEffect(() => {
      
      // let openTmp : boolean =  false
      // for(let opt in openButtons){
      //   let value : boolean = openButtons[opt]
      //   openTmp = openTmp || value
      // }

      let openTmp : boolean | undefined =  false
      openTmp =  openButtons.optConfig || openButtons.optFileDoc || openButtons.optHelp || openButtons.optIndex || openButtons.optNotes || openButtons.optReviews || openButtons.optAuthor || openButtons.optReferences || openButtons.optIA || openButtons.optPodcast
      if(openTmp){
        setOpen(true)
      }else{
        setOpen(false)
      }
      // setOpen(openTmp)
    }, [openButtons])



    return (
        <>
      {/* <!-- [right] section --> */}
      <div className="l1-wrapper__right">
        <div className={`aside ${open || isOpenSideBar ?"expanded":""}`}>

          {/* Contenido de autores */}
          <Authors
            openButtons = {openButtons}
            setOpenButtons = {setOpenButtons}
          />

          <References
            openButtons = {openButtons}
            setOpenButtons = {setOpenButtons}
          />

          {/* <!-- CONTENIDO OPCIONES DE USUARIO --> */}
          <UserOptions 
            openButtons = {openButtons}
            setOpenButtons = {setOpenButtons}
          ></UserOptions>
          {/* <!-- CONTENIDO OPCIONES DE USUARIO --> */}

          {/* <!-- INDICE DE CAPITULO --> */}
          <ChapterIndex
            openButtons = {openButtons}
            setOpenButtons = {setOpenButtons}          
          ></ChapterIndex>
          {/* <!-- content 1 end --> */}

          <IaChat
            openButtons = {openButtons}
            setOpenButtons = {setOpenButtons}          
          ></IaChat>

          <Podcast
            openButtons = {openButtons}
            setOpenButtons = {setOpenButtons}          
          ></Podcast>
          <ReviewsComponent
            openButtons = {openButtons}
            setOpenButtons = {setOpenButtons}          
          ></ReviewsComponent>

          {/* <!-- content 3 --> */}
          <NotesComponent
            openButtons = {openButtons}
            setOpenButtons = {setOpenButtons}          
          ></NotesComponent>
          {/* <!-- content 3 end --> */}

          {/* <!-- content 4 --> */}
          <DataSheet
            openButtons = {openButtons}
            setOpenButtons = {setOpenButtons}          
          ></DataSheet>
          {/* <!-- content 4 end --> */}

          {/* <!-- content 5 --> */}
          {/* <!-- content 5 end --> */}

          {/* <!-- content 7 --> */}
          <HelpBook
            viewButtons = {viewButtons}
            openButtons = {openButtons}
            setOpenButtons = {setOpenButtons}     
          />
        </div>
        <div className={`backdrop-m ${isOpenSideBar ? 'visible-fadein' : ''}`}></div>
        {/* <!-- [right] section end --> */}


        {/* <!-- modal credits --> */}
      <ModalCredits
      ></ModalCredits>

      {/* <ModalFragments /> */}
      <FullscreenFragmentViewer />
        
        
        {/* <!-- modal credits end --> */}
      </div>            
        </>
    )
}

export default RightSection
